import { useMemo } from "react";

interface Map {
  [key: string]: string | undefined;
}

interface OffsetMap {
  [key: string]: Map;
}

const COLOR_THEME: Map = {
  white: "stroke-white",
  black: "stroke-black",
};

const OFFSET: OffsetMap = {
  prev: {
    big: "left-4",
    small: "left-0",
    default: "-left-14",
  },
  next: {
    big: "right-4",
    small: "right-0",
    default: "-right-14",
  },
};

const SlickArrow = ({
  onClick,
  currentSlide,
  slideCount,
  slidesToScroll,
  slidesToShow,
  isInfinite,
  color,
  offset,
  direction,
}: any): JSX.Element => {
  const isNextArrow = useMemo(() => {
    return direction === "next";
  }, [direction]);

  const isVisible = useMemo(() => {
    let value = true;
    if (isNextArrow) {
      // Visibility logic of next arrow
      const ceilCurrentSlide = Math.ceil(currentSlide);
      const offSet = slideCount - 1;

      if (isInfinite) {
        value = true;
      } else {
        value = ceilCurrentSlide + Math.ceil(slidesToShow) - 1 < offSet;
      }
    } else {
      // Visibility logic of prev arrow
      value = currentSlide > 0 || isInfinite;
    }
    return value;
  }, [
    isNextArrow,
    isInfinite,
    currentSlide,
    slidesToShow,
    slideCount,
    slidesToScroll,
  ]);

  const classes = useMemo(() => {
    const directionClasses = isNextArrow
      ? OFFSET.next[offset] ?? OFFSET.next.default
      : OFFSET.prev[offset] ?? OFFSET.prev.default;

    return `absolute z-[1] top-[42%] p-5 cursor-pointer desktop:hidden desktopLarge:block ${
      COLOR_THEME[color] ?? COLOR_THEME.black
    } ${directionClasses}`;
  }, [isNextArrow, color, offset]);

  const shadowStyle = useMemo(() => {
    if (color === "white") {
      return {
        filter: "drop-shadow(0px 3px 3px rgb(0 0 0 / 1))",
      };
    }
    return {};
  }, [color]);

  return (
    <>
      {isVisible && (
        <div className={classes} style={shadowStyle} onClick={onClick}>
          <svg
            width="11"
            height="27"
            viewBox="0 0 11 27"
            fill="none"
            transform={isNextArrow ? "" : "rotate(180)"}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1.91406L9 13.4858L1 25.9141"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
      )}
    </>
  );
};

export default SlickArrow;
